<template>
  <div v-if="renderReady">
    <label v-if="getTitle" class="label">
      {{ getTitle }}
      <!-- <w-tooltip :tooltip="tooltipContent"></w-tooltip> -->
    </label>
    <div class="input" :class="{ 'state-error': model.$error, 'state-disabled': disabled && !borderless }">
      <input
        v-if="!datePickerVisible"
        type="text"
        ref="input"
        :placeholder="datepicker.options.placeholder"
        :value="model.$value"
        readonly="readonly"
        autocomplete="off"
        @focus="toggleDatePicker()"
      />
      <i v-if="model.$model" class="fa fa-times clear" @click="clear"></i>
      <datepicker
        v-if="datePickerVisible"
        ref="datePicker"
        :placeholder="datepicker.options.placeholder"
        :language="datepicker.language"
        :format="datepicker.options.format"
        :value="model.$model"
        :clear-button="datepicker.options.clearButton"
        :disabled="disabled"
        :full-month-name="true"
        @input="dateChanged"
        @focus="onFocus($event)"
        @blur="pickerBlur($event)"
        @closed="pickerBlur($event)"
      ></datepicker>
    </div>
    <w-error :model="model" @focus="datePickerVisible ? $refs.input.focus() : $refs.datePicker.focus()"></w-error>
  </div>
</template>

<script>
import modelMixin from '@/mixins/modelMixin';

import WError from './error.vue';
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js';
import { pl } from 'vuejs-datepicker/dist/locale';
import * as moment from 'moment';

export default {
  components: { WError, Datepicker },
  props: {
    placeholder: String,
    dateOptions: Object
  },
  mixins: [modelMixin],
  data() {
    const dateOpts = {
      placeholder: this.placeholder || '',
      format: 'dd.MM.yyyy'
    };
    return {
      datePickerVisible: false,
      datepicker: {
        language: pl,
        value: '',
        options: { ...dateOpts, ...this.dateOptions }
      }
    };
  },
  // computed: {},
  methods: {
    toggleDatePicker() {
      if (this.datePickerVisible) {
        this.hideDatePicker();
      } else {
        if (!this.model.$schema.readOnly) {
          this.showDatePicker();
        }
      }
    },
    showDatePicker() {
      this.datePickerVisible = true;
      const self = this;
      // pokae się dopiero za chwilę
      this.$nextTick(() => {
        self.$refs.datePicker.$el.children[0].children[0].focus();
        self.$refs.datePicker.showCalendar();
      });
    },
    hideDatePicker() {
      this.datePickerVisible = false;
      this.$nextTick(() => {
        // self.$refs.datePicker.showCalendar();
      });
    },
    pickerBlur($event) {
      console.log('pickerBlur');
      this.hideDatePicker();
      // onBlur($event);
    },

    dateChanged(newValue) {
      const tnewvalue = newValue.getTime();
      if (tnewvalue !== this.localValue) {
        this.localValue = tnewvalue;
        const stringValue = moment(newValue).format('DD.MM.YYYY');
        this.$emit('input', stringValue);
        this.fieldChanged();

        if (!this.$options.vmodel) {
          if (this.$options.lazy) {
            return;
          }
          // sets in model
          const nvalue = moment(newValue).format('YYYY-MM-DD');
          this.model.$model = nvalue;
        }
      }
    },

    clear() {
      this.model.$model = '';
      this.$emit('input', this.model.$model);
    }
    /*

    clickOutside() {
      this.hideDatePicker();

      document.removeEventListener('click', this.clickOutside, true);
    }
    */
  },
  watch: {
    dateOptions(next, prev) {
      this.datepicker.options = { ...this.datepicker.options, ...next };
    },
    placeholder(next, prev) {
      this.$set(this.datepicker.options, 'placeholder', next);
    }
  }
};
</script>

<style>
.vdp-datepicker__calendar .cell.selected {
  color: #fff;
  background-color: #a90329;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  background-color: #428bca;
  color: white;
}
.vdp-datepicker__calendar header {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}
.vdp-datepicker__calendar .cell {
  border: 1px solid transparent !important;
}
.vdp-datepicker__calendar .cell.selected::before,
.vdp-datepicker__calendar .cell.selected::after {
  content: none;
}
</style>

<style scoped>
.input {
  position: relative;
}
.input .clear {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
